import { withStyles, Button } from '@material-ui/core';
const styles = (theme) => ({
  dialogActionStyle: {
    width: '53%',
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'flex-end',
    margin: "12 0 12 0",
  },
  dialogButtonStyle: {
    fontSize: theme.textFontSize,
    textTransform: 'none',
    borderRadius: '2px',
    float: 'right',
    width: '48%',
    '&$disabledButton,&$disabledButton:hover': {
      cursor: 'not-allowed',
      pointerEvents: 'all',
      backgroundColor: theme.customInputBGColor,
      color: theme.white
    }
  },
  disabledButton: {
    cursor: 'not-allowed',
    pointerEvents: 'all',
    backgroundColor: theme.iconColor,
    color: theme.white
  }
});

const Action = (props) => {
  const { isLoading, onClick, classes, onClose } = props;

  return (
    <div className={classes.dialogActionStyle}>
      <Button
        id="cancel"
        onClick={onClose}
        color="primary"
        variant="outlined"
        size="medium"
        classes={{
          root: classes.dialogButtonStyle,
          disabled: classes.disabledButton
        }}>
        Cancel
      </Button>
      <Button
        id="update"
        disabled={isLoading}
        onClick={onClick}
        color="primary"
        variant="contained"
        classes={{
          root: classes.dialogButtonStyle,
          disabled: classes.disabledButton
        }}>
        Update
      </Button>
    </div>
  );
};

export default withStyles(styles)(Action);
